import useSWR from "swr";
import { useApiClient } from "@/hooks/useApiClient";
import { type AxiosError } from "axios";
import type { RequestedPicturesPlotDataResponse } from "@/features/map/types";

/**
 * @param enable APIリクエストを有効にするかのフラグ. trueの場合のみ/map/requested-picturesへGETリクエストを行う
 */
export const useRequestedPicturesPlot = (
  enable: boolean
): {
  requestedPictures: RequestedPicturesPlotDataResponse[] | undefined;
  isLoading: boolean;
  isError: boolean;
} => {
  const { apiClient } = useApiClient();

  const fetcher = async (
    url: string
  ): Promise<RequestedPicturesPlotDataResponse[]> => {
    const response = await apiClient.get<RequestedPicturesPlotDataResponse[]>(
      url
    );
    return response.data;
  };

  const { data, error } = useSWR<
    RequestedPicturesPlotDataResponse[],
    AxiosError
  >(
    enable ? "/map/requested-pictures" : null, // enableがtrueの時のみリクエストを投げる
    fetcher,
    {
      revalidateOnFocus: false,
    }
  );

  return {
    requestedPictures: data,
    isLoading: !error && !data,
    isError: !!error,
  };
};
